import { Component } from '@angular/core';
import { PageLayoutComponent } from '../../../components/shared/page-layout/page-layout.component';

@Component({
  selector: 'app-assurance-rc-pro-juridique',
  standalone: true,
  imports: [PageLayoutComponent],
  templateUrl: './assurance-rc-pro-juridique.component.html',
  styleUrl: './assurance-rc-pro-juridique.component.scss'
})
export class AssuranceRcProJuridiqueComponent {
  title = 'Assurance RC Pro Juridique';
  subtitle = 'Protection pour les professionnels du droit et du conseil';
  heroImage = 'assets/images/hero-rc-juridique.jpg';
  
  breadcrumbs = [
    { label: 'Professionnels', link: undefined },
    { label: 'RC Pro Juridique', link: undefined }
  ];

  prevPage = { title: 'RC Pro Médicale', link: '/assurance-rc-pro-medicale'
  };

  nextPage = { title: 'Protection Juridique', link: '/assurance-protection-juridique'
  };
}
